import { useState } from 'react';
import { useFieldArray } from 'react-hook-form';
import { listContacts } from 'services/lead/leadServices';

export function useRelationships(control, watch) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'relations',
  });

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectedContact = watch('contact.contact_id');
  const selectedClient = watch('client.contact_id');

  const searchAsync = async (e) => {
    try {
      setLoading(true);
      const response = await listContacts({ contactType: '', keyWord: e?.query, pageLimit: 20, excludeFromLoading: true, in_lead: true });
      const filteredContacts = response?.data?.contacts?.filter((c) => c?.contact_id !== (selectedContact || selectedClient)) || [];

      // Sort contacts alphabetically by first_name for persons, and by title for businesses
      const sortedContacts = filteredContacts.sort((a, b) => {
        const aName = a?.contact_type === 'person' ? a?.first_name?.toLowerCase() || '' : a?.title?.toLowerCase() || '';
        const bName = b?.contact_type === 'person' ? b?.first_name?.toLowerCase() || '' : b?.title?.toLowerCase() || '';
        return aName.localeCompare(bName);
      });

      setResults(sortedContacts);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  const removeItem = (item) => {
    const index = fields.findIndex((v) => v.contact_id === item.contact_id);
    if (index !== -1) {
      remove(index);
    }
  };

  return {
    fields,
    append,
    removeItem,
    remove,
    results,
    loading,
    searchAsync,
  };
}
